import { MessageCircle } from 'lucide-react';

const WHATSAPP_NUMBER = '+919876543210';
const WHATSAPP_MESSAGE = 'Hi! I would like to inquire about your services.';

const WhatsAppButton = () => {
  const whatsappLink = `https://wa.me/${WHATSAPP_NUMBER.replace(/\+/g, '')}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      className="whatsapp-float"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={28} className="text-white" />
    </a>
  );
};

export default WhatsAppButton;
